// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/" + {"2453":"7dd9f8dcb82cdb4f0e17","3715":"7e46e69f3c0b74b9afe5","3769":"41bae454c0132177e110","7228":"18d693c238da7ed94580","7503":"efdc06dc1bcc840c2564"}[chunkId] + "-bundle.js";
};